/* RebelsMarket — shared cm/in unit toggle for code-owned fit charts.
   Used by the jacket size chart, the shoe size chart, and the shoe width chart
   (all rendered inside snippets/size-chart-drawer.liquid). One delegated
   listener, bound once.

   Markup contract:
     <div data-rm-unit-root>
       <button data-rm-unit="in" class="is-active">in</button>
       <button data-rm-unit="cm">cm</button>
       <table data-rm-unit-table data-rm-base="in"> ... <tbody><td>26.5</td>
       <span data-rm-unit-label>inches</span>            (optional)

   Table options (attributes on [data-rm-unit-table]):
     data-rm-base   "in" | "cm"  — the unit the cells are authored in (default in)
     data-rm-cols   "3" or "3,4" — 1-based td indexes to convert; omit = all td.
                     Use this when a table mixes convertible lengths with values
                     that must never convert (e.g. the shoe chart's US/EU/UK sizes).
     data-rm-dec-in  decimals when showing inches (default 1)
     data-rm-dec-cm  decimals when showing cm     (default 0)

   Cells are authored in data-rm-base units; the original text is cached once
   (data-rm-orig) so both directions stay exact. Any numbers in the cell convert,
   including ranges like "40–42". Cells marked data-rm-keep are left alone. */
(function () {
  if (window.__rmUnitToggleBound) return;
  window.__rmUnitToggleBound = true;

  function convert(text, from, to, decIn, decCm) {
    if (from === to) return text;
    return text.replace(/\d+(?:\.\d+)?/g, function (m) {
      var v = parseFloat(m);
      if (to === 'cm') {
        var c = v * 2.54;
        return decCm > 0 ? c.toFixed(decCm) : String(Math.round(c));
      }
      var inch = v / 2.54;
      return decIn > 0 ? inch.toFixed(decIn) : String(Math.round(inch));
    });
  }

  function intAttr(el, name, dflt) {
    var n = parseInt(el.getAttribute(name), 10);
    return isNaN(n) ? dflt : n;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rm-unit]');
    if (!btn) return;
    var root = btn.closest('[data-rm-unit-root]');
    if (!root) return;
    var unit = btn.getAttribute('data-rm-unit'); // 'in' | 'cm'

    root.querySelectorAll('[data-rm-unit]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    root.querySelectorAll('[data-rm-unit-table]').forEach(function (table) {
      var base = table.getAttribute('data-rm-base') || 'in';
      var decIn = intAttr(table, 'data-rm-dec-in', 1);
      var decCm = intAttr(table, 'data-rm-dec-cm', 0);
      var colsAttr = table.getAttribute('data-rm-cols');
      var cols = colsAttr ? colsAttr.split(',').map(function (s) { return parseInt(s, 10); }) : null;

      table.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.querySelectorAll('td').forEach(function (td, i) {
          if (cols && cols.indexOf(i + 1) === -1) return; // 1-based td index
          if (td.hasAttribute('data-rm-keep')) return;
          if (!td.hasAttribute('data-rm-orig')) td.setAttribute('data-rm-orig', td.textContent.trim());
          td.textContent = convert(td.getAttribute('data-rm-orig'), base, unit, decIn, decCm);
        });
      });
    });

    root.querySelectorAll('[data-rm-unit-label]').forEach(function (lbl) {
      lbl.textContent = unit === 'cm' ? 'cm' : 'inches';
    });
  });
})();
